// import firebase from 'firebase'
// import 'firebase/storage'

// export const app = firebase.initializeApp({
//     apiKey: "AIzaSyDRyv441ggjwxiUH5fBaOYv3VgBEdqFGzw",
//     authDomain: "amp--v2.firebaseapp.com",
//     databaseURL: "https://amp--v2.firebaseio.com",
//     projectId: "amp--v2",
//     storageBucket: "amp--v2.appspot.com",
//     messagingSenderId: "968831356955",
//     appId: "1:968831356955:web:b8a1fe118b408c9b0468be",
//     measurementId: "G-S1CXWZDF6M"
// });

import firebase from 'firebase'
import 'firebase/storage'

export const app = firebase.initializeApp({
    apiKey: "AIzaSyCt7ns6oShS1MtWx2hY9ow3jkha-FvXMR8",
    authDomain: "amp-2-c2c4f.firebaseapp.com",
    projectId: "amp-2-c2c4f",
    storageBucket: "amp-2-c2c4f.firebasestorage.app",
    messagingSenderId: "969236907111",
    appId: "1:969236907111:web:14fba62bc39bfdd79b80c2",
    measurementId: "G-7WTSNHV296"
});

